import { render } from "./FeaturedTyre.vue?vue&type=template&id=19d90930&scoped=true"
import script from "./FeaturedTyre.vue?vue&type=script&lang=js"
export * from "./FeaturedTyre.vue?vue&type=script&lang=js"

import "./FeaturedTyre.vue?vue&type=style&index=0&id=19d90930&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19d90930"]])

export default __exports__